import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styles from "../../../constants/assets/variables";
import { getInitialState } from "../../../utils/index";
import * as ConfigChangeLogActions from "../../../store/actions/ConfigChangeLog";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";

const ChangeLogFilterFormModal = (props) => {
  const [formError, setFormError] = useState("");
  const [initialState, setInitialState] = useState({
    event: "",
    start_date: " ",
    end_date: " ",
    action_by: "",
  });
  const {
    handleClose,
    activeFilters,
    Source,
    cityId,
    filterFields,
    getList,
    setLogsList,
  } = props;

  const handleFilterClick = (evt) => {
    evt.preventDefault();
    const filters = {};
    for (let key of filterFields) {
      if (initialState[key] && initialState[key].trim().length > 0) {
        filters[key] = initialState[key];
      }
    }
    if (
      filters["start_date"] &&
      filters["end_date"] &&
      Date.parse(filters["start_date"]) > Date.parse(filters["end_date"])
    ) {
      setFormError(
        "Invalid Date, start_date should be smaller than or equal to end_date"
      );
    } else {
      if (Source === "General Setting") {
        props.getGenSettingChangeLog(filters).then((res) => {
          setLogsList(res.change_logs);
          props.SetActiveFilterChangeLog(filters);
        });
        handleClose();
      } else {
        props.getCityPropertyChangeLog(filters, {}, cityId).then((res) => {
          setLogsList(res.change_logs);
          props.SetActiveFilterChangeLog(filters);
        });
        handleClose();
      }
    }
  };

  const handleClearFilters = () => {
    getList();
    props.resetState({ state: "activeChangeLogFilters" });
    handleClose();
  };

  const getEndDate = () => {
    const endDateObj = new Date();
    const endDateStr = `${endDateObj.getFullYear()}-${`0${
      endDateObj.getMonth() + 1
    }`.slice(-2)}-${`0${endDateObj.getDate()}`.slice(-2)}`;
    return endDateStr;
  };

  const getStartDate = (endDate) => {
    const startDateObj = new Date(new Date(endDate).getTime() - 6 * 86400000);
    const startDateStr = `${startDateObj.getFullYear()}-${`0${
      startDateObj.getMonth() + 1
    }`.slice(-2)}-${`0${startDateObj.getDate()}`.slice(-2)}`;
    return startDateStr;
  };

  const checkIfDisabled = () => {
    let flag = 1;
    Object.keys(initialState).map((key) => {
      if (initialState[key] !== "" && initialState[key] !== " ") {
        flag = 0;
      }
    });
    return flag;
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;

    if (key === "end_date") {
      if (!values["start_date"]) {
        values["start_date"] = getStartDate();
      }
    } else if (key === "start_date") {
      if (!values["end_date"]) {
        values["end_date"] = getEndDate(val);
      }
    }
    setInitialState(values);
  };

  useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      const values = { ...initialState };
      Object.keys(values).map((key) => {
        values[key] = activeFilters[key]
          ? activeFilters[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <section>
      <NoFooterModal
        header={true}
        heading="Apply Filters"
        handleClose={handleClose}
        id="changeLogFilterFormModal"
        modalButtons={
          <BottomSectionModal>
            <FlexContainer>
              <Button
                data-testid="saveButton"
                disabled={checkIfDisabled()}
                onClick={handleFilterClick}
                className="sushi-btn"
              >
                Apply
              </Button>
              <Button
                data-testid="saveButton"
                disabled={checkIfDisabled()}
                onClick={handleClearFilters}
                className="sushi-btn"
              >
                Clear
              </Button>
            </FlexContainer>
          </BottomSectionModal>
        }
      >
        <InputForm name="filter-details">
          <Input
            id="sushi-input"
            fullWidth={true}
            borderColor={styles.primaryColor}
            value={initialState.event}
            label="Event"
            onChange={(val) => handleChange("event", val)}
          />
          <Input
            id="sushi-input"
            fullWidth={true}
            label="Action By"
            value={initialState.action_by}
            onChange={(val) => handleChange("action_by", val)}
          />
          <Input
            id="sushi-input"
            value={initialState.start_date}
            fullWidth={true}
            label="Start Date"
            type="date"
            onChange={(val) => handleChange("start_date", val)}
          />
          <Input
            id="sushi-input"
            fullWidth={true}
            value={initialState.end_date}
            label="End Date"
            type="date"
            onChange={(val) => handleChange("end_date", val)}
          />
        </InputForm>
        {formError.length > 0 ? (
          <div className={"error-state"}>{"*" + formError}</div>
        ) : (
          ""
        )}
      </NoFooterModal>
    </section>
  );
};

const InputForm = styled.form`
  #sushi-input {
    margin-bottom: 20px;
  }
`;

const mapStateToProps = (state) => {
  const { ConfigChangeLog } = state;
  return {
    currentPage: ConfigChangeLog.currentPage,
    activeFilters: ConfigChangeLog.activeChangeLogFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCityPropertyChangeLog: bindActionCreators(
      ConfigChangeLogActions.getCityPropertyChangeLog,
      dispatch
    ),
    getGenSettingChangeLog: bindActionCreators(
      ConfigChangeLogActions.getGenSettingChangeLog,
      dispatch
    ),
    SetActiveFilterChangeLog: bindActionCreators(
      ConfigChangeLogActions.SetActiveFilterChangeLog,
      dispatch
    ),
    resetState: bindActionCreators(ConfigChangeLogActions.resetState, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeLogFilterFormModal);
